export const toolEn = {
  timestamp: {
    title: 'Unix Timestamp Converter',
    subtitle: 'Convert between Unix timestamps and human-readable dates with auto-detection, live mode, and batch processing.',
    seo: {
      title: 'Unix Timestamp Converter - Live, Batch & Auto-Detect | CikaStudio',
      description: 'Free Unix timestamp converter with live mode, auto-detection (seconds/ms/μs/ns), batch conversion, timezone support, and rich date metadata. 100% client-side and privacy-focused.',
    },
    liveMode: {
      title: 'Current Timestamp',
      description: 'Live updating every second',
      pause: 'Pause',
      resume: 'Resume',
      copyHint: 'Click to copy',
    },
    conversion: {
      timestampToDate: 'Timestamp → Date',
      dateToTimestamp: 'Date → Timestamp',
      swapDirection: 'Swap Direction',
    },
    input: {
      placeholder: 'Enter timestamp...',
      label: 'Input',
    },
    unit: {
      seconds: 'Seconds',
      milliseconds: 'Milliseconds',
      microseconds: 'Microseconds',
      nanoseconds: 'Nanoseconds',
      auto: 'Auto-detect',
    },
    timezone: {
      label: 'Timezone',
      local: 'Local',
    },
    output: {
      label: 'Converted Result',
      formats: 'Output Formats',
    },
    format: {
      iso8601: 'ISO 8601',
      rfc2822: 'RFC 2822',
      sql: 'SQL Datetime',
      unixSeconds: 'Unix (Seconds)',
      unixMilliseconds: 'Unix (Milliseconds)',
      unixMicroseconds: 'Unix (Microseconds)',
      unixNanoseconds: 'Unix (Nanoseconds)',
      humanReadable: 'Human Readable',
    },
    metadata: {
      title: 'Date Metadata',
      dayOfWeek: 'Day of Week',
      dayOfYear: 'Day of Year',
      weekNumber: 'Week Number',
      quarter: 'Quarter',
      leapYear: 'Leap Year',
      dst: 'DST Active',
      timezone: 'Timezone',
      utcOffset: 'UTC Offset',
      yes: 'Yes',
      no: 'No',
      active: 'Active',
      inactive: 'Inactive',
    },
    batch: {
      title: 'Batch Conversion',
      single: 'Single',
      batch: 'Batch',
      placeholder: 'Paste timestamps here, one per line...',
      convert: 'Convert',
      downloadCSV: 'Download CSV',
      clearAll: 'Clear All',
      column: {
        input: 'Input',
        unit: 'Unit',
        iso: 'ISO 8601',
        local: 'Local Time',
        seconds: 'Unix (s)',
        milliseconds: 'Unix (ms)',
      },
    },
    error: {
      invalidTimestamp: 'Invalid timestamp. Please enter a valid number.',
      invalidDate: 'Invalid date. Please select a valid date and time.',
      outOfRange: 'Timestamp is out of supported date range.',
    },
  },
  content: {
    privacy: {
      title: 'Privacy & Security',
      description: '🔒 All timestamp conversions happen locally in your browser. No data is uploaded to any server.',
    },
    guide: {
      title: 'How to Use Timestamp Converter',
      description: 'Convert between Unix timestamps and human-readable dates with auto-detection, live mode, and batch processing.',
      steps: [
        { title: 'Enter a timestamp or date', description: 'Paste a Unix timestamp (seconds or milliseconds) or type a human-readable date. The tool auto-detects the input format.' },
        { title: 'View conversions', description: 'See the converted value in multiple formats: local time, UTC, ISO 8601, and the original timestamp. Live mode updates in real-time.' },
        { title: 'Process batches', description: 'Paste multiple timestamps or dates (one per line) to convert them all at once. Copy the results to your clipboard or download as a CSV file.' },
      ],
    },
    features: {
      title: 'Key Features',
      items: [
        'Auto-detection of seconds and milliseconds timestamps',
        'Multiple output formats: local, UTC, ISO 8601',
        'Live mode with real-time updating clock',
        'Batch processing for multiple values',
        'Copy and CSV download support',
        '100% client-side processing — zero data upload',
      ],
    },
    faq: {
      title: 'Frequently Asked Questions',
      items: [
        { question: 'Is my data sent to a server?', answer: 'No. All conversions happen entirely within your browser using JavaScript Date objects. Your timestamps never leave your device.' },
        { question: 'Does it handle timezone conversions?', answer: 'Yes. The converter displays both your local timezone and UTC. You can also enter dates with timezone offsets for precise conversion.' },
        { question: 'What is the Unix epoch?', answer: 'The Unix epoch is January 1, 1970, 00:00:00 UTC. Unix timestamps count the number of seconds (or milliseconds) since this point in time.' },
      ],
    },
    related: {
      title: 'Related Tools',
      tools: [
        { name: 'Cron Parser', url: '/developer/cron-parser', description: 'Parse standard cron expressions into human-readable schedules.' },
        { name: 'Unit Converter', url: '/converter/unit-converter', description: 'Convert between 10+ unit categories instantly.' },
        { name: 'Percentage Calculator', url: '/utility/percentage-calculator', description: 'Instant percentage calculations in your browser.' },
      ],
    },
  },
};